import(/* webpackMode: "eager" */ "/app/packages/frontend/src/app/[locale]/error.tsx");
